import { $http } from '@/plugins/common/http';

export const getAwsAccounts = (query) => {
    return $http.get('/aws-accounts', {
        params: {
            ...query,
        },
    });
};

export const getDealers = (query) => {
    return $http.get('/dealers', {
        params: {
            ...query,
        },
    });
};

export const addDealer = (data) => {
    return $http.post(`/dealers`, {
        ...data,
    });
};

export const editDealer = (id, data) => {
    return $http.put(`/dealers/${id}`, {
        ...data,
    });
};

export const getAwsAccountDetail = (id) => {
    return $http.get(`/aws-accounts/${id}`);
};

export const changeAwsAccountStatus = (id, isActive) => {
    return $http.patch(`/aws-accounts/${id}/active`, {
        isActive,
    });
};

export const addBalanceRecord = (id, data) => {
    return $http.post(`/aws-accounts/${id}/balance-record`, {
        ...data,
    });
};

export const getBalanceRecords = (id, query) => {
    return $http.get(`/aws-accounts/${id}/balance-records`, {
        params: {
            ...query,
        },
    });
};

export const editAwsAccount = (id, data) => {
    return $http.put(`/aws-accounts/${id}`, {
        ...data,
    });
};

export const addAwsAccount = (data) => {
    return $http.post(`/aws-accounts`, {
        ...data,
    });
};

export const getAwsAccountInvoice = (id, year, month) => {
    return $http.get(`/aws-accounts-invoice/${id}/${year}/${month}`);
};

export const getPayerAwsAccounts = (query) => {
    return $http.get('/payer-accounts', {
        params: {
            ...query,
        },
    });
};

export const getPayerAwsAccountDetail = (id) => {
    return $http.get(`/payer-accounts/${id}`);
};

export const editPayerAwsAccount = (id, data) => {
    return $http.put(`/payer-accounts/${id}`, {
        ...data,
    });
};

export const addPayerAwsAccount = (data) => {
    return $http.post(`/payer-accounts`, {
        ...data,
    });
};

export const getAwsAccountTempCredential = (id) => {
    return $http.get(`/aws-accounts-tempcredential/${id}`);
};

export const changePayerAccountStatus = (id, isShared) => {
    return $http.patch(`/payer-accounts/${id}/shared`, {
        isShared,
    });
};
